import { Component, Input } from "@angular/core"
import { ColorPaletteService } from "@shared/services/color-palette.service"
import { IconImageService } from "@shared/services/icon-image.service"

@Component({
  selector: "flow-badge",
  templateUrl: "./flow-badge.component.html",
  styleUrl: "./flow-badge.component.scss",
  standalone: false,
})
export class FlowBadgeComponent {
  @Input() text: string = ""
  @Input() color: AgColor = "Neutral"
  @Input() size: AgSize = "Medium"
  @Input() type: AgType = "Default"
  @Input() icon: string = this.iconService.Icon.plus

  constructor(public iconService: IconImageService, private colorPalette: ColorPaletteService) {}

  public getBadgeColor(): string {
    if (this.type !== "Status") {
      return this.color.toLowerCase()
    }
    return "neutral"
  }

  public getBorderColor(): string {
    if (this.type === "Status") {
      return "#D6D3D1"
    } else {
      switch (this.color) {
        case "Neutral":
          return "#D6D3D1"
        case "Yellow":
          return "#FEF08A"
        case "Orange":
          return "#FED7AA"
        case "Red":
          return "#FECACA"
        case "Green":
          return "#BBF7D0"
        case "Blue":
          return "#BFDBFE"
        case "Purple":
          return "#E9D5FF"
      }
    }
  }

  public getBackgroundColor(): string {
    if (this.type === "Status") {
      return "#FFFFFF"
    } else {
      return ""
    }
  }

  public getTextColor(): string {
    if (this.type === "Status") {
      return "#78716C"
    } else {
      return ""
    }
  }
}

export type AgSize = "Micro" | "Medium" | "Large"
export type AgType = "Default" | "Status"
export type AgColor = "Neutral" | "Yellow" | "Orange" | "Red" | "Green" | "Blue" | "Purple"
